import { cn } from "@/lib/utils";

export function Table({ columns, rows, testid, onRowClick, empty = "No records" }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-800" data-testid={testid}>
      <table className="w-full min-w-[640px] text-sm">
        <thead>
          <tr className="border-b border-slate-800 bg-slate-900/60">
            {columns.map((c) => (
              <th key={c.key} className="px-4 py-3 text-left font-mono text-[10px] font-semibold uppercase tracking-widest text-slate-500">{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-sm text-slate-500">{empty}</td></tr>
          )}
          {rows.map((r, i) => (
            <tr key={r.id || i}
              onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={cn("border-b border-slate-800/60 transition-colors hover:bg-slate-800/40", onRowClick && "cursor-pointer")}>
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-3 align-middle text-slate-300">
                  {c.render ? c.render(r) : r[c.key] ?? "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
